/**
 * A common mixin for add and edit appointment header
 * Author: Tirthamouli Baidya
 */
import AddEventToggle from "../components/Appointment/AddAppointment/AddToggle/AddEventToggle";
import AddPersonToggle from "../components/Appointment/AddAppointment/AddToggle/AddPersonToggle";
import AddGroupToggle from "../components/Appointment/AddAppointment/AddToggle/AddGroupToggle";

export const addEditAppointmentHeaderMixin = {
  components: {
    AddEventToggle, // The add event toggle
    AddPersonToggle, // The add person toggle
    AddGroupToggle // The add group toggle
  }
};
